<template>
  <div class="hourly-average-cotaine">
    <el-table
      v-show="showTableData.length"
      :data="showTableData"
      border
      style="width: 100%"
      height="700"
    >
      <el-table-column
        v-for="(item, index) in tableHeaderData"
        :key="index"
        :prop="item.value"
        :label="item.label"
      ></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    tableData: {
      type: Object
    }
  },
  data() {
    return {
      showTableData: [],
      tableHeaderData: []
    };
  },
  watch: {
    tableData: {
      handler(newVal) {
        if (!newVal) {
          return;
        }
        if (newVal.dataList && newVal.dimensions && newVal.dimensionsZh) {
          this.showTableData = [];
          this.tableHeaderData = [];

          this.showTableData = newVal.dataList;

          newVal.dimensions.forEach((item, index) => {
            let obj = {
              value: newVal.dimensions[index],
              label: newVal.dimensionsZh[index]
            };
            this.tableHeaderData.push(obj);
          });
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped></style>
